import { client } from '../client';
import { ICase } from './types/ICase';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export type PatientCancelReasonCode =
  | 'NO_LONGER_AVAILABLE'
  | 'NO_LONGER_NEEDS_HELP'
  | 'RECEIVED_HELP_ELSEWHERE'
  | 'PLATFORM_PROBLEMS'
  | 'ACCIDENTAL_MULTIPLE_CASES'
  | 'OTHER';

export type StaffCancelReasonCode =
  | 'PATIENT_NO_LONGER_AVAILABLE'
  | 'PATIENT_NO_LONGER_NEEDS_HELP'
  | 'PATIENT_RECEIVED_HELP_ELSEWHERE'
  | 'PATIENT_PLATFORM_PROBLEMS'
  | 'PATIENT_ACCIDENTAL_MULTIPLE_CASES'
  | 'PATIENT_DID_NOT_ATTEND'
  | 'PROVIDER_DID_NOT_ATTEND'
  | 'OTHER';

export type CancelReasonCode = PatientCancelReasonCode | StaffCancelReasonCode;

export interface CancelCaseRequest {
  reason_code: CancelReasonCode;
  reason_other?: string | null;
}

export async function cancelCase(case_id: number, payload: CancelCaseRequest, userRole?: string): Promise<ICase> {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.put<ICase>(`${prefix}/cases/${case_id}/cancel`, payload);

  return data;
}
